namespace GeniuzPOS.ReportMasterData {
    export class Report_1317Columns {
        static columnsKey = 'ReportMasterData.Report_1317';
    }
}
